module.exports = __webpack_public_path__ + "img/icon-ontzorgd.73b8edfba46e9bdfaaf801c5d324058e.svg";